















import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import Api from '@/api'
import { UserModule } from '@/store/modules/user.module'
import { mapGetters } from 'vuex'
import { getIdFromEntityField, IEligibilityTask, IUser, ZUNTA_DATA_ENTRY_ID } from '@zunta/configurations'
import BaseHeader from '@/components/layout/BaseHeader.vue'
import Tabs from '@/components/layout/Tabs.vue'
import { EligibilityTaskModule } from '@/store/modules/eligibilityTask.module'

@Component({
  components: {
    Tabs,
    BaseHeader,
    Icon
  },
  computed: {
    ...mapGetters({
      user: 'user/getUser'
    })
  }
})
export default class Header extends Vue {
  user!: IUser
  userModule: UserModule = getModule(UserModule, this.$store)
  eligibilityTaskModule: EligibilityTaskModule = getModule(EligibilityTaskModule, this.$store)
  adminEligibilityTasksCount: number = 0

  get getTabsList () {
    if (this.user && this.user.role && getIdFromEntityField(this.user.role) === ZUNTA_DATA_ENTRY_ID) {
      return this.tabList.filter(tab => ['admin-uploads', 'admin-eligibility-tasks', 'admin-pcc-deposits'].includes(tab.key))
    } else {
      return this.tabList
    }
  }

  get tabList () {
    return [
      {
        key: 'admin-dashboard',
        value: { name: 'admin-dashboard' },
        content: 'Dashboard'
      },
      {
        key: 'admin-todo',
        value: { name: 'admin-todo' },
        content: 'To Do'
      },
      {
        key: 'admin-chains',
        value: { name: 'admin-chains' },
        content: 'Chains'
      },
      {
        key: 'admin-users',
        value: { name: 'admin-users' },
        content: 'Users'
      },
      {
        key: 'admin-facilities-users',
        value: { name: 'admin-facilities-users' },
        content: 'Facilities Users'
      },
      {
        key: 'admin-billing',
        value: { name: 'admin-billing' },
        content: 'Billing'
      },
      {
        key: 'admin-facilities',
        value: { name: 'admin-facilities' },
        content: 'Facilities'
      },
      {
        key: 'admin-milestones',
        value: { name: 'admin-chains-milestones' },
        content: 'Milestones'
      },
      {
        key: 'admin-payments',
        value: { name: 'admin-payments' },
        content: 'Payments'
      },
      {
        key: 'admin-uploads',
        value: { name: 'admin-uploads' },
        content: 'Uploads'
      },
      {
        key: 'admin-pcc-deposits',
        value: { name: 'admin-pcc-deposits' },
        content: 'PCC Deposits'
      },
      {
        key: 'admin-eligibility-tasks',
        value: { name: 'admin-eligibility-tasks' },
        content: 'Eligibility',
        badgeText: this.adminEligibilityTasksCount
      }
    ]
  }

  async mounted () {
    this.adminEligibilityTasksCount = await this.eligibilityTaskModule.countPendingTasks()
    this.$eventBus.$on('notifyEligibilityTaskUpdate', (data: { tasksCount?: number}) => {
      if (typeof data.tasksCount === 'number' && !isNaN(data.tasksCount)) {
        this.adminEligibilityTasksCount = data.tasksCount
      }
    })
  }

  logout () {
    Api.logout()
    this.$router.push({ name: 'login' })
  }
}
